import {autoinject, bindable, ViewResources, View, ViewSlot, ViewCompiler} from "aurelia-framework";
import {transient, Container} from "aurelia-dependency-injection";

@autoinject
@transient()
export class CompDynamicView {

    private _view: View;
    private _viewSlot: ViewSlot;
    public dynamicViewSlotElem: HTMLElement;

    @bindable
    public content: string | HTMLElement | View | (() => string | HTMLElement | View);

    @bindable
    public resources: ViewResources;

    @bindable
    public bindingContext: any;

    @bindable
    public overrideContext: any;

    public constructor(private resourcesExisting: ViewResources, private viewCompiler: ViewCompiler, private container: Container) { }

    attached() {
        this._viewSlot = new ViewSlot(this.dynamicViewSlotElem, true);
        this.contentChanged()
    }

    detached() {
        if (this._view && this._viewSlot) {
            this._view.detached();
            this._view.unbind();
            this._viewSlot.remove(this._view);
            this._view = null;
        }
        if (this._viewSlot) {
            this._viewSlot.detached();
            this._viewSlot = null;
        }
    }

    bindingContextChanged() {
        if (this._view) {
            this._view.bind(this.bindingContext, this.overrideContext, true);
        }
    }

    overrideContextChanged() {
        if (this._view) {
            this._view.bind(this.bindingContext, this.overrideContext, true);
        }
    }

    public contentChanged(): void {
        if (!this._viewSlot || !this.content) {
            return;
        }

        let content = this.content;
        if (typeof this.content === "function") {
            content = this.content();
        }

        let view: View;
        if (content instanceof View) {
            view = content;
        } else {
            let html = '';
            if (typeof content === "string") {
                html = <string>content;
            } else if (content instanceof HTMLElement) {
                html = content.outerHTML;
            } else {
                throw "content can be only a string or a HTMLElement";
            }
            const viewFactory = this.viewCompiler.compile(`<template>${html}</template>`, this.resources || this.resourcesExisting);
            view = viewFactory.create(this.container);
        }
        if (this._view) {
            this._view.detached();
            this._view.unbind();
            this._viewSlot.remove(this._view);
        }
        this._view = view;
        this._viewSlot.add(view);
        this._view.created();
        this._view.bind(this.bindingContext, this.overrideContext, true);
        this._view.attached();
    }
}
